















































































































































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { CollectionStatus } from '@/types'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface InputEditBasicItem {
  collectionId: {
    input: number
    errorMessage: string
  }
  collectionNo: {
    input: string
    errorMessage: string
  }
  collectionType: {
    input: string
    errorMessage: string
  }
  storeType: {
    input: string
    errorMessage: string
  }
  opacShow: {
    input: boolean
    errorMessage: string
  }
  status: {
    input: string
    errorMessage: string
  }
  handlingType: {
    input: string
    errorMessage: string
  }
  appendixCode: {
    input: string
    errorMessage: string
  }
  removeReason: {
    input: string
    errorMessage: string
  }
  // 日付
  removeDate: {
    input: string
    errorMessage: string
  }
  // 日付
  removeExpectedDate: {
    input: string
    errorMessage: string
  }
  // 日付
  publishDate: {
    input: string
    errorMessage: string
  }
  parentCollectionNo: string
  parentComposedCollectionNo: {
    input: string
    errorMessage: string
  }
  setNumber: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditBasicItem = (): InputEditBasicItem => ({
  collectionId: {
    input: 0,
    errorMessage: ''
  },
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    errorMessage: ''
  },
  storeType: {
    input: '',
    errorMessage: ''
  },
  opacShow: {
    input: false,
    errorMessage: ''
  },
  status: {
    input: '',
    errorMessage: ''
  },
  handlingType: {
    input: '',
    errorMessage: ''
  },
  appendixCode: {
    input: '',
    errorMessage: ''
  },
  removeReason: {
    input: '',
    errorMessage: ''
  },
  // 日付
  removeDate: {
    input: '',
    errorMessage: ''
  },
  // 日付
  removeExpectedDate: {
    input: '',
    errorMessage: ''
  },
  // 日付
  publishDate: {
    input: '',
    errorMessage: ''
  },
  parentCollectionNo: '',
  parentComposedCollectionNo: {
    input: '',
    errorMessage: ''
  },
  setNumber: {
    input: '',
    errorMessage: ''
  }
})

const STATUS_EXCLUSION_CODES: string[] = [
  CollectionStatus.Lending,
  CollectionStatus.LendingUnregistered,
  CollectionStatus.ReceiveWaiting,
  CollectionStatus.ReceiveForwarding,
  CollectionStatus.TempAccept
]

const LOST_CODES: string[] = [
  CollectionStatus.LostProcedure,
  CollectionStatus.Lost
]

@Component({
  components: {
    InputCollectionNo,
    InputCode,
    InputDatePicker
  }
})
export default class CollectionEditCollectionBasicInfo extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  LostCollectionOnDisabled!: boolean

  @Prop({
    type: String,
    default: ''
  })
  currentStatus!: string

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditBasicItem

  get isStatusRemove(): boolean {
    return this.inputItem.status.input === CollectionStatus.Removed
  }

  get disabledParentComposedCollectionNo(): boolean {
    return (
      this.inputItem.status.input !== CollectionStatus.PreparingToAccept &&
      this.inputItem.status.input !== CollectionStatus.Shelf &&
      this.inputItem.status.input !== CollectionStatus.Repairing &&
      this.inputItem.status.input !== CollectionStatus.Composed
    )
  }

  get shouldStatusDisabled(): boolean {
    return (
      this.currentStatus === CollectionStatus.Composed ||
      this.statusExclusionCodes.includes(this.currentStatus) ||
      (LOST_CODES.includes(this.currentStatus) && this.LostCollectionOnDisabled)
    )
  }

  get statusExclusionCodes(): string[] {
    return STATUS_EXCLUSION_CODES
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  onInputStatus(value: string): void {
    this.inputItem.status.input = value
    this.$nextTick(() => {
      this.resetErrorMessage(this.inputItem.status)
      if (this.statusExclusionCodes.includes(this.inputItem.status.input)) {
        this.inputItem.status.input = ''
      }
    })
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
